import { InjectionToken } from '@angular/core';
import { UserSettingsGateway } from '@prlw/core/user-settings/user-settings-gateway.interface';

export const USER_SETTINGS_GATEWAY = new InjectionToken<UserSettingsGateway>(
  'user-settings-gateway',
);
